import type { Order } from "../../../../../../../services";
import type { TFunction } from "i18next";

const cellProcessing = (item: Order.Model, t: TFunction): string => {
	const lastReceivedOrder =
		item?.additionalFields?.transfer?.lastReceivedOrder;

	const comment = (() => {
		const toValue = item.closedOrderComments?.[0];

		if (toValue?.status === "hide_by_transfer") {
			return lastReceivedOrder?.closedOrderComments?.[0];
		}
		return toValue;
	})();

	const reason = comment ? t(`order_closed_status.${comment.status}`) : "";

	const by = (() => {
		if (!comment) return "";

		if (comment.dispatcher) return t(`order_closed_by.dispatcher`);
		if (comment.executor) return t(`order_closed_by.executor`);
		if (comment.customer) return t(`order_closed_by.customer`);

		return "";
	})();

	return `${reason} ${by ? `(${by})` : ""}`.trim();
};

export default cellProcessing;
